module.exports = __webpack_public_path__ + "img/user.e6bf2745.png";